import { onMounted } from 'vue';
import { useCommercialGoalsStore } from 'dashboard/stores/commercialGoals';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';

const REFRESH_INTERVAL = 30000;

// Um único polling por página: os componentes só leem `progress`/`myProgress`
// do store. As metas independem dos filtros do dashboard.
export const useGoalsProgress = ({ mine = false } = {}) => {
  const store = useCommercialGoalsStore();

  // Falha silenciosa: sem metas, a tela segue sem barras.
  const refresh = async () => {
    try {
      await (mine ? store.fetchMyProgress() : store.fetchProgress());
    } catch {
      // mantém as últimas metas carregadas
    }
  };

  const { startRefetching } = useLiveRefresh(refresh, REFRESH_INTERVAL);

  onMounted(() => {
    refresh();
    startRefetching();
  });
};
